import { Controller } from '@hotwired/stimulus';

import { driver } from 'driver.js';

export default class extends Controller {
  static targets = ['new', 'menu', 'search', 'view'];

  static values = {
    skip: String,
    back: String,
    next: String,
    finish: String,
    title: String,
  };

  connect() {
    this.driverObj = driver({
      showProgress: true,
      nextBtnText: this.nextValue,
      prevBtnText: this.backValue,
      doneBtnText: this.finishValue,

      overlayColor: '#555',
      popoverClass: 'driverjs-theme',

      steps: [
        {
          element: this.newTarget,
          popover: {
            title: this.titleValue,
            description: this.newTarget.dataset.tourDashboardNewText,
          },
        },
        {
          element: this.menuTarget,
          popover: {
            title: this.titleValue,
            description: this.menuTarget.dataset.tourDashboardMenuText,
          },
        },
        {
          element: this.searchTarget,
          popover: {
            title: this.titleValue,
            description: this.searchTarget.dataset.tourDashboardSearchText,
          },
        },
        {
          element: this.viewTarget,
          popover: {
            title: this.titleValue,
            description: this.viewTarget.dataset.tourDashboardViewText,
          },
        },
      ],
    });
  }

  start() {
    this.driverObj.drive();
  }

  disconnect() {
    this.driverObj.destroy();
  }
}
